import ready from '../components/_ready';

ready(() => {
  const whereToAttend = document.getElementsByClassName('js--where-to-attend');
  if (!whereToAttend) return;

  if (whereToAttend.length > 0) {
    if (window.location.hash === '#where-to-attend') {
      whereToAttend[0].classList.add('active');
    }
  }

  const languageMenu = document.querySelector('.js--language-menu');
  languageMenu?.addEventListener('click', (event) => {
    event.preventDefault();
  });
});
